import { MINUTE, SECOND } from '@gorila-shared-ui/components';
import moment from 'moment';
import 'moment/locale/es';

export const getStartDate = () => {
  return new Date().setHours(0, 0, 0, 0);
};

export const getStartDateFromDate = (date: Date) => {
  return date.setHours(0, 0, 0, 0);
};

export const getEndDate = () => {
  return new Date().setHours(23, 59, 59, 999);
};

export const getEndDateFromDate = (date: Date) => {
  return date.setHours(23, 59, 59, 999);
};

export const getMinutesAndSecondsDifference = (from: number, to: number): { minutes: number; seconds: number } => {
  const diffMs = new Date(to).getTime() - new Date(from).getTime(); // difference in milliseconds
  const totalSeconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return { minutes, seconds };
};

export const roundUpToNextInterval = (date: Date, interval: number) => {
  const ms = date.getTime();
  const roundedMs = Math.ceil(ms / (interval * 60_000)) * interval * 60_000;
  return new Date(roundedMs);
};

export const roundToClosestInterval = (date: Date, interval: number) => {
  const ms = date.getTime();
  const roundedMs = Math.round(ms / (interval * 60_000)) * interval * 60_000;
  return new Date(roundedMs);
};

export const roundUpToNextIntervalTime = (interval: number = 15, date: Date = new Date()) => {
  return roundUpToNextInterval(date, interval).getTime();
};

export const roundToClosestIntervalTime = (interval: number = 15, date: Date = new Date()) => {
  return roundToClosestInterval(date, interval).getTime();
};

export const timePlusMinutesFromSeconds = (ts: number, seconds: number) => {
  const minutes = Math.round(seconds / 60);
  return ts + minutes * MINUTE;
};

export const formatDurationFromSeconds = (seconds?: number, shortSuffix = false) => {
  if (!seconds) return '-';
  const duration = moment.duration(seconds, 'seconds');

  const days = duration.days();
  const daysSuffix = shortSuffix ? 'd' : `día${days !== 1 ? 's' : ''}`;
  const hours = duration.hours();
  const hoursSuffix = shortSuffix ? 'h' : `hora${hours !== 1 ? 's' : ''}`;
  const minutes = duration.minutes();
  const minutesSuffix = shortSuffix ? 'm' : `minuto${minutes !== 1 ? 's' : ''}`;
  const secs = duration.seconds();
  const secsSuffix = shortSuffix ? 's' : `segundo${secs !== 1 ? 's' : ''}`;

  const parts = [];
  if (days) parts.push(`${days} ${daysSuffix}`);
  if (hours) parts.push(`${hours} ${hoursSuffix}`);
  if (minutes) parts.push(`${minutes} ${minutesSuffix}`);
  if (secs || parts.length === 0) parts.push(`${secs} ${secsSuffix}`);

  return parts.join(' ');
};

export const timeMinusMinutes = (ts: number, minutes: number) => {
  return ts - minutes * MINUTE;
};

export const timePlusMinutes = (ts: number, minutes: number) => {
  return ts + minutes * MINUTE;
};

export const timeMinusSeconds = (ts: number, seconds: number) => {
  return ts - seconds * SECOND;
};

export const timePlusSeconds = (ts: number, seconds: number) => {
  return ts + seconds * SECOND;
};

export const getLastMonthsList = (n: number): { id: string; label: string }[] => {
  moment.locale('es');

  const results: { id: string; label: string }[] = [];

  for (let i = 0; i < n; i++) {
    const m = moment().subtract(i, 'months');
    results.push({
      id: m.format('YYYYMM'),
      label: m.format('MMMM').replace(/^\w/, (c) => c.toUpperCase()), // capitalize first letter
    });
  }

  return results;
};
